import ReactECharts from 'echarts-for-react';
import dayjs from 'dayjs';
import { useMemo } from 'react';
import { chartColors, chartGrid, chartText } from '../../lib/chartColors';
import AnnotatedTimeChart from './AnnotatedTimeChart';

export default function TerritoryComparisonChart({ series = [], metric = 'average_price', height = 430, fuel = 'BENZINA' }) {
  const dates = useMemo(() => [...new Set(series.flatMap(s => s.items.map(x => x.snapshot_date)))].sort(), [series]);
  const chartSeries = useMemo(() => series.map((s, i) => {
    const map = Object.fromEntries(s.items.map(x => [x.snapshot_date, Number(x[metric])]));
    return { name: s.territory.name, type: 'line', symbol: 'none', connectNulls: false, data: dates.map(d => map[d] ?? null), lineStyle: { width: i === 0 ? 4 : 2.6, color: chartColors[i % chartColors.length], cap: 'round' }, itemStyle: { color: chartColors[i % chartColors.length] }, emphasis: { focus: 'series' } };
  }), [series, metric, dates]);
  const option = useMemo(() => {
    return {
      animationDuration: 420,
      grid: { left: 54, right: 14, top: 72, bottom: 42 },
      legend: { top: 4, type: 'scroll', textStyle: { fontFamily: 'Rubik', fontSize: 11, color: chartText, fontWeight: 500 }, itemWidth: 18, itemHeight: 8 },
      tooltip: {
        trigger: 'axis',
        backgroundColor: '#fff8f9',
        borderWidth: 0,
        padding: 12,
        textStyle: { fontFamily: 'Rubik', color: '#24191c' },
        extraCssText: 'border-radius:18px;box-shadow:0 2px 8px rgba(35,25,27,.14);',
        formatter: params => {
          const i = params?.[0]?.dataIndex ?? 0;
          const date = dates[i] ? dayjs(dates[i]).format('DD/MM/YYYY') : '';
          return `<b>${date}</b><br>${params.filter(p => p.value !== null && p.value !== undefined).map(p => `${p.marker} ${p.seriesName}: <b>${Number(p.value).toFixed(3)} €</b>`).join('<br>')}`;
        },
      },
      xAxis: { type: 'category', data: dates, boundaryGap: false, axisLabel: { hideOverlap: true, color: chartText, fontFamily: 'Rubik', fontSize: 10, formatter: v => dayjs(v).format('DD/MM') }, axisLine: { lineStyle: { color: chartGrid } }, axisTick: { show: false } },
      yAxis: { type: 'value', scale: true, axisLabel: { formatter: v => `${Number(v).toFixed(2)} €`, color: chartText, fontFamily: 'Rubik', fontSize: 10 }, splitLine: { lineStyle: { color: chartGrid } }, axisLine: { show: false }, axisTick: { show: false } },
      dataZoom: [{ type: 'inside', filterMode: 'none' }],
      series: chartSeries,
    };
  }, [dates, chartSeries]);

  if(fuel!=='BENZINA'&&fuel!=='GASOLIO') return <ReactECharts option={option} style={{height}}/>;
  return <AnnotatedTimeChart
    option={option}
    dates={dates}
    height={height}
    fuels={[fuel]}
    analysisSeries={chartSeries.map(item=>({name:item.name,values:item.data}))}
  />;
}
